import React, { Component } from 'react'
import { faCheckCircle, faEnvelope, faShippingFast, faHeadset, faHome, faReceipt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export class PaymentSucces extends Component {
  render() {
    return (
        <div className='flex justify-center items-center'>
            <div className="max-w-md w-full bg-white rounded-2xl shadow-lg overflow-hidden">
            {/* Başlıq hissəsi */}
            <div className="bg-green-50 py-8 px-6 text-center">
            <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <FontAwesomeIcon icon={faCheckCircle} className="text-green-500 text-4xl" />
            </div>
            <h1 className="text-2xl font-bold text-gray-800 mb-2">
                Ödəniş Uğurla Tamamlandı!
            </h1>
            <p className="text-gray-600">
                Sifarişiniz qəbul edildi və emal edilir
            </p>
            </div>

            {/* Məlumat hissəsi */}
            <div className="p-6">
            <div className="bg-gray-50 rounded-lg p-4 mb-6">
                <h2 className="font-semibold text-gray-700 mb-3">Sifariş Məlumatları</h2>
                <div className="space-y-2">
                <div className="flex justify-between">
                    <span className="text-gray-600">Sifariş №:</span>
                    <span className="font-medium">#AZ20230527</span>
                </div>
                <div className="flex justify-between">
                    <span className="text-gray-600">Məbləğ:</span>
                    <span className="font-medium">49.90 AZN</span>
                </div>
                <div className="flex justify-between">
                    <span className="text-gray-600">Ödəniş Metodu:</span>
                    <span className="font-medium">Kart</span>
                </div>
                <div className="flex justify-between">
                    <span className="text-gray-600">Tarix:</span>
                    <span className="font-medium">27 May 2023, 14:30</span>
                </div>
                </div>
            </div>

            <div className="mb-6">
                <h2 className="font-semibold text-gray-700 mb-3">Növbəti Addımlar</h2>
                <ul className="space-y-3">
                <li className="flex items-start">
                    <FontAwesomeIcon icon={faEnvelope} className="text-green-500 mt-1 mr-3" />
                    <span className="text-gray-600">
                    Sifariş təfərrüatları e-poçt ünvanınıza göndəriləcək
                    </span>
                </li>
                <li className="flex items-start">
                    <FontAwesomeIcon icon={faShippingFast} className="text-green-500 mt-1 mr-3" />
                    <span className="text-gray-600">
                    Sifarişiniz 3-5 iş günü ərzində çatdırılacaq
                    </span>
                </li>
                <li className="flex items-start">
                    <FontAwesomeIcon icon={faHeadset} className="text-green-500 mt-1 mr-3" />
                    <span className="text-gray-600">
                    Hər hansı sualınız varsa, dəstək komandamızla əlaqə saxlayın
                    </span>
                </li>
                </ul>
            </div>

            {/* Əməliyyat düymələri */}
            <div className="flex flex-col sm:flex-row gap-3">
                <button className="flex-1 bg-green-500 hover:bg-green-600 text-white font-medium py-3 px-4 rounded-lg transition duration-200 flex items-center justify-center">
                <FontAwesomeIcon icon={faHome} className="mr-2" />
                Ana Səhifəyə Qayıt
                </button>
                
            </div>

            {/* Əlavə məlumat */}
            <div className="mt-6 text-center">
                <p className="text-sm text-gray-500">
                Sifarişinizin statusunu izləmək üçün{" "}
                <a
                    href="#"
                    className="text-green-500 hover:text-green-600 font-medium"
                >
                    Bizimlə Əlaqə Saxlayın
                </a>{" "}
                saxlayın.
                </p>
            </div>
            </div>
            </div>
        </div>
    )
  }
}

export default PaymentSucces
